import { Box, Paper, Typography } from "@mui/material";

const TLBillingStatement = () => (
  <Box m={{ xs: 1.5, md: 3 }}>
    <Typography variant="h3" fontWeight={800}>Billing Statement</Typography>
    <Typography color="text.secondary" mb={2}>Prepare and manage customer billing statements.</Typography>
    <Paper
      elevation={0}
      sx={{ minHeight: 420, p: 3, border: "1px solid", borderColor: "divider", borderRadius: 3 }}
    >
      <Typography color="text.secondary">The Billing Statement transaction list will be displayed here.</Typography>
    </Paper>
  </Box>
);

export default TLBillingStatement;
